import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApButtonComponent } from '@ap/button';
import { ApContentPipe } from '@ap/content';
import { ApModalComponent } from '@ap/modal';

import { FeedbackFormModule } from '../form/form.module';

import { FeedbackModalComponent } from './modal.component';

/**
 * @ngdoc module
 * @name FeedbackModalModule
 **/
@NgModule({
    declarations: [FeedbackModalComponent],
    imports: [ApButtonComponent, ApContentPipe, ApModalComponent, CommonModule, FeedbackFormModule],
    exports: [FeedbackModalComponent]
})
export class FeedbackModalModule {}
